import { Injectable } from '@angular/core';
import { FieldType } from 'angular-slickgrid';

@Injectable({
  providedIn: 'root'
})
export class PlanRequestModalService {

  constructor() { }

  getRequestModalColumnConfigs() {
    return [
      {
        id: 'id',
        name: 'Seq No',
        field: '',
        sortable: true,
        formatter: function (row) { return (row + 1); },
        minWidth: 30
      },
      {
        id: 'request_no',
        name: 'Request No.',
        field: 'request_no',
        sortable: true,
        type: FieldType.string,
        minWidth: 80
      },
      {
        id: 'ORIGIN',
        name: 'Origin',
        field: 'ORIGIN',
        sortable: true,
        type: FieldType.string,
        minWidth: 180
      },
      {
        id: 'DESTINATION',
        name: 'Destination',
        field: 'DESTINATION',
        sortable: true,
        type: FieldType.string,
        minWidth: 210
      },
      {
        id: 'PAYLOAD_TYPE',
        name: 'Payload Type',
        field: 'PAYLOAD_TYPE',
        sortable: true,
        type: FieldType.string,
        minWidth: 150
      },
      {
        id: 'WEIGHT',
        name: 'Weight',
        field: 'WEIGHT',
        sortable: true,
        type: FieldType.string,
        minWidth: 80
      },
      {
        id: 'VOLUME',
        name: 'Volume',
        field: 'VOLUME',
        sortable: true,
        type: FieldType.string,
        minWidth: 80
      },
      {
        id: 'QUANTITY',
        name: 'Quantity',
        field: 'QUANTITY',
        sortable: true,
        type: FieldType.string,
        minWidth: 80
      },
      {
        id: 'UOM',
        name: 'UOM',
        field: 'UOM',
        sortable: true,
        type: FieldType.string,
        minWidth: 80
      },
      // {
      //   id: 'VEHICLE_REG_NO',
      //   name: 'Vehicle Number',
      //   field: 'VEHICLE_REG_NO',
      //   sortable: true,
      //   type: FieldType.string,
      //   minWidth: 120
      // },
      {
        id: 'DESCRIPTION',
        name: 'Name/Item Description',
        field: 'DESCRIPTION',
        sortable: true,
        type: FieldType.string,
        minWidth: 280
      },
      {
        id: 'CONTACT_NO',
        name: 'Contact No.',
        field: 'CONTACT_NO',
        sortable: true,
        type: FieldType.string,
        columnGroup: 'Plan Details',
        minWidth: 100
      },
      {
        id: 'REQUEST_FROM_DATE',
        name: 'Req Pick Date-Time',
        field: 'REQUEST_FROM_DATE',
        sortable: true,
        type: FieldType.string,
        minWidth: 120
      },
      {
        id: 'REQUEST_TO_DATE',
        name: 'Req Drop Date-Time',
        field: 'REQUEST_TO_DATE',
        sortable: true,
        type: FieldType.string,
        minWidth: 120
      },
      {
        id: 'PLAN_FROM_DATE',
        name: 'Plan From Date and Time',
        field: 'PLAN_FROM_DATE',
        sortable: true,
        type: FieldType.string,
        minWidth: 120
      },
      {
        id: 'PLAN_TO_DATE',
        name: 'Plan To Date and Time',
        field: 'PLAN_TO_DATE',
        sortable: true,
        type: FieldType.string,
        minWidth: 120
      },
      {
        id: 'STATUS',
        name: 'Request Status',
        field: 'STATUS',
        sortable: true,
        type: FieldType.string,
        minWidth: 120
      }];
  }

  gridConfigs(scope) {
    return {
      idField: '',
      gridId: 'planreqmodalTable',
      recStatus: 'I',
      containerHeight: '98vh',
      canExportAsExcel: true, // TODO: Need to Configure
      selectionMode: 'multiple', // TODO: Need to configure
      exportFileName: 'Plan ReqNo',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: false,
      canDeleteRowManually: false,
      canCopyRows: false,
      showColumnFilter: false,
      emptyObject: {},
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: false,
      enableRowSelection: true,
      editable: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true
      },
      createPreHeaderPanel: false,
      showPreHeaderPanel: false,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: false,
      autoCommitEdit: true,
      hideClearAllFiltersCommand: true,
      hideClearAllSortingCommand: true,
      hideToggleFilterCommand: true,
      hideExportCsvCommand: true,
      hideExportTextDelimitedCommand: true,
      hideRefreshDatasetCommand: true,
      enableHeaderMenu: true,
      showFilter: true
    };
  }
}
